import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDotsHorizontal = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.3125 8C3.3125 8.55228 2.86478 9 2.3125 9C1.76022 9 1.3125 8.55228 1.3125 8C1.3125 7.44771 1.76022 7 2.3125 7C2.86478 7 3.3125 7.44771 3.3125 8ZM9 8C9 8.55228 8.55228 9 8 9C7.44772 9 7 8.55228 7 8C7 7.44772 7.44772 7 8 7C8.55228 7 9 7.44772 9 8ZM14.6875 8C14.6875 8.55228 14.2398 9 13.6875 9C13.1352 9 12.6875 8.55228 12.6875 8C12.6875 7.44772 13.1352 7 13.6875 7C14.2398 7 14.6875 7.44772 14.6875 8Z",
		fill: "currentColor"
	})
});
export default SvgDotsHorizontal;
